import React from 'react';
import { graphql, navigate } from 'gatsby';
import styled from 'styled-components';
import {
  sectionPaddings,
  standardColours,
  brandFonts,
  fontWeights,
  fontSize,
  minBreakpointQuery,
  standardTransition,
  brandColours,
} from '../styles';
import { Container, Link } from './ui';
import { buildUrl } from '../utils';

const StyledLinkCards = styled.section`
  ${sectionPaddings(undefined, '90px')};
  background-color: ${standardColours.lightGrey};
`;

const StyledWrapper = styled.div`
  display: grid;
  row-gap: 35px;
  justify-content: center;
  align-items: center;

  ${minBreakpointQuery.medium`
    grid-template-columns: repeat(3, 1fr);
    column-gap: 20px;
  `}
`;

const StyledLinkCard = styled.article`
  text-align: center;
  background-color: ${standardColours.white};
  padding: 50px 40px;
  max-width: 500px;
  transition: ${standardTransition('background-color')};

  &:hover {
    background-color: ${brandColours.primary};
  }
`;

const StyledHeading = styled.h3`
  font-family: ${brandFonts.secondary};
  font-weight: ${fontWeights.regular};
  ${fontSize(25)}

  ${minBreakpointQuery.large`
    ${fontSize(30)}
  `}
`;

const StyledText = styled.p`
  margin-top: 30px;
  line-height: 1.7;
`;

const LinkCards = ({ items }) => (
  <StyledLinkCards>
    <Container>
      <StyledWrapper>
        {items.map(({ heading, text, link }, id) => (
          <StyledLinkCard
            key={id}
            onClick={() => navigate(buildUrl(link.page.slug, link.page))}
          >
            <StyledHeading>
              <Link to={link.page}>{heading}</Link>
            </StyledHeading>
            <StyledText>{text}</StyledText>
          </StyledLinkCard>
        ))}
      </StyledWrapper>
    </Container>
  </StyledLinkCards>
);

export default LinkCards;

export const LinkCardsFragment = graphql`
  fragment LinkCardsFragment on DatoCmsLinkCardItem {
    heading
    text
    link {
      page {
        ...LinkFragment
      }
    }
  }
`;
